<template>
    <div class="product-simple col-12 product-single product-single-custom">
        <div class="ttn_content product_ttn_content">
            <notifications></notifications>
            <div class="container product-container p-0" style="max-width: 1005px">
                <div class="page-main-category" :data-classname="'product_cat_' + parentCategory.id " :class="product.categories.find(i => i.slug === 'uncategorized') ? 'uncategorized' : ''">{{ categories[0].name }}</div>
                <div class="row mb-5">
                    <div class="col-md-6 mb-5 mb-md-0">
                        <div class="product_slider single-product-slider topchange">
                            <div class="post-title-mobile d-sm-none">{{ product.title }}</div>
                            <div :id="product.attachments.length > 1 ? 'main-slider' : 'single-slider'">
                                <div :class="{'carousel carousel-main init-flickity': product.attachments.length > 1}" :id="product.attachments.length > 1 ? 'main-carousel' : 'single-carousel'">
                                    <div v-for="attachment in product.attachments" class="carousel-cell">
                                        <div class="post">
                                            <wrap-image :fancy="'product'" :prop-image="attachment" prop-size="small" prop-class="image-carousel"/>
                                            <div v-if="product.attachments.length >= 1 && attachment.name" class="post-title post-title d-sm-block d-none">{{ attachment.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="product.attachments.length > 1" data-main="main-carousel" class="carousel carousel-nav init-flickity-nav">
                                <div v-for="attachment in product.attachments" class="carousel-cell">
                                    <wrap-image :prop-image="attachment" prop-size="small" prop-class="not-fancy"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" :class="product.fillPrice ? 'fill_price' : ''">
                        <div class="product_details">
                            <h1 class="product_title">{{ product.title }}</h1>
                            <span class="woocommerce-Price-amount amount upper-price custom_fit_price" v-if="product.slug == 'box-beam-coffered-ceiling-systems-custom-fit'">
                                <bdi>{{ cartItem ? priceFormatter(cartItem.price) : priceFormatter(product.price) }}</bdi>
                                {{ (cartItem && cartItem.show_price_per_unit && !!cartItem.price_label) ? cartItem.price_label  : (product.show_price_per_unit && !!product.price_label ? product.price_label : '') }}
                            </span>
                            <!-- <div class="price d-md-block d-flex" v-if="this.cartItem.price && (isUncategorized || cartItem.stock_status !== 'in_stock')">
                                <span class="txt d-sm-none">PRICE</span>
                                <span class="amount">{{ `${priceFormatter(cartItem.price)} ${product.show_price_per_unit && !!product.price_label ? product.price_label  : ''}` }}</span>
                                <span v-if="cartItem.stock_status !== 'in_stock'" class="amount">{{ `${priceFormatter(cartItem.price)} ${product.show_price_per_unit && !!product.price_label ? product.price_label  : ''}` }}</span>
                            </div> -->
                            <p v-if="product.excerpt" class="short_description" v-html="product.excerpt"></p>
                            <form class="variations_form cart" onSubmit="return false;">
                                <add-to-cart
                                    :product="product"
                                    :cart-item="cartItem"
                                    :varaitions-price-show="1"
                                    :isadmin="isadmin"
                                />
                            </form>
                        </div>
                        <div class="mb-4 product-content" v-if="product.content">
                            <div v-if="product.content" class="w-100 ml-auto mr-auto post_excerpt" v-html="product.content"></div>
                        </div>
                        <div class="product_meta w-100">
                            <span v-if="sku" class="item-sku">SKU: {{ sku }}</span>
                            <span v-if="categories.length && !isUncategorized" class="item-sku">Category:
                                <a v-for="(category, index) in categories" :href="category.url">{{category.name}}{{ index + 1 < categories.length ? ', ' : ''}}</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <product-tabs :prop-product-id="product.id" :prop-description="product.description" :prop-preview="this.isPreview"/>
                </div>
                <div class="row mt-4">
                    <div class="col-md-6">
                        <div class="jason_box_mobile">
                            <div class="row">
                                <div class="col-12">
                                    <div class="jason_box">
                                        <h4>Have any questions about this product?</h4>
                                        <div class="text-center">
                                            <img loading="lazy"   alt="Jason Tilton of Tilton Coffered Ceilings" width="150" height="150" src="/images/person/jason_tilton.jpg" class="mb-3" />
                                            <p class="name">Jason Tilton</p>
                                            <p class="position">President &amp; Inventor&nbsp;</p>
                                            <a href="mailto:jason@TiltonCofferedCeilings.com" class="mail_link">Jason@TiltonCofferedCeilings.com</a>
                                            <a href="tel:800-396-6410" class="phone_link">Call Me Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="getProductLinkedProducts.length" class="row">
                    <section>
                        <h2 class="linked_products_sec page-second-title w-100 mb-4 pl-3">You may also like...</h2>
                        <div class="col-6 col-sm-4 col-md-3 col-lg-3" v-for="linkedProduct in getProductLinkedProducts">
                            <product-list-item :prop-linked-product="linkedProduct"/>
                        </div>
                    </section>
                </div>
            </div>
            <div v-if="$store.getters.isSuperAdmin || $store.getters.isAdmin" class="row m-0">
                <div class="col-12">
                    <a target="_blank" :href="$data._configs.baseUrl  + '/admin/products/' + product.id + '/edit' ">Edit</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductTabs from "./ProductTabs";
import WrapImage from "../WrapImage";
import Notifications from "../Notifications";
import AddToCart from "../AddToCart";
import {mapActions, mapGetters} from "vuex";
import ProductListItem from "../cart/ProductListItem";

export default {
    name: 'product-simple',
    props: ['propProduct','propIsadmin','propPreview'],
    components: {
        AddToCart,
        Notifications,
        WrapImage,
        ProductTabs,
        ProductListItem
    },
    data() {
        return {
            isPreview: this.propPreview,
        }
    },
    mounted() {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const hidableBlock = document.querySelector('.mobile-hidden')
        if (isMobile && hidableBlock){
            hidableBlock.style.display = "none"
        }
        this.productLinkedProducts(this.product)
        this.dataLayerViewItem(this.product);
    },
    methods: {
        ...mapActions(['productLinkedProducts']),
        dataLayerViewItem(selectedVariation)
        {
            window.dataLayer = window.dataLayer || [];

            if(selectedVariation)
            {
                let products = [];
                let items = [];

                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = selectedVariation ? selectedVariation.sku : "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = selectedVariation ? selectedVariation.price : "";
                this.$store.state.data_layer_view_item.ecommerce.value = selectedVariation ? selectedVariation.price : "";

                let options =  "";
                let category =  this.cartItem && this.cartItem.categories.length > 0 ? this.cartItem.categories[0].meta_title : "";

                products[0] = {};
                products[0].brand = "";
                products[0].category = category;
                products[0].id = selectedVariation ? selectedVariation.sku : "";
                products[0].name = selectedVariation ? selectedVariation.title : "";
                products[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                products[0].stocklevel = "";
                products[0].variant = options ? options.join(",") : "";

                items[0] = {};
                items[0].google_business_vertical = "retail";
                items[0].id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_brand = "";
                items[0].item_category = category;
                items[0].item_id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_name = selectedVariation ? selectedVariation.title : "";
                items[0].item_variant = options ? options.join(",") : "";
                items[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";

                this.$store.state.data_layer_change_detail_view_eec.ecommerce.detail.products = products;
                this.$store.state.data_layer_view_item.ecommerce.items = items;

                // for(let i=0; i<obj1Keys.length; i++) {
                //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
                // }

                // for(let i=0; i<obj2Keys.length; i++) {
                //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.changeDetailsDataLayer[obj2Keys[i]];
                // }

                window.dataLayer.push(this.$store.getters.changeDetailsDataLayer[0]);
                window.dataLayer.push(this.$store.getters.changeDetailsDataLayer[1]);
            }
            else
            {
                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = "0.00";
                this.$store.state.data_layer_view_item.ecommerce.value = "0.00";
            }
        }
    },
    computed: {
        ...mapGetters(['getProductLinkedProducts']),
        product() {
            return this.mapProductItem(this.propProduct)
        },
        isadmin() {
            return this.propIsadmin
        },
        sku() {
            return this.product.sku
        },
        categories() {
            return this.product.categories.map(i => ({url: i.publish_url, name: i.name, slug: i.slug}))
        },
        cartItem() {
            return this.mapCartItem({product: this.product})
        },
        parentCategory() {
            return this.product.categories[0].parent ? this.product.categories[0].parent : this.product.categories[0]
        },
        isUncategorized() {
            return this.categories.filter(i => i.slug === 'uncategorized').length
        }
    },
}
</script>
<style>
.variations_form.cart
{
    /* margin-bottom: 0px !important; */
    margin-top: 30px !important;
}
</style>
